import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, catchError, Observable, switchMap } from 'rxjs';
import { CalAngularService } from '@cvx/cal-angular';
import { environment } from 'src/environments/environment';

@Injectable()
export class CalInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(private authService: CalAngularService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return this.authService.getAADToken([environment.apiTokenScope]).pipe(
      switchMap((token) => {
        const cloned = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
        return next.handle(cloned);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !this.isRefreshing) {
          this.isRefreshing = true;
          this.refreshTokenSubject.next(null);

          return this.authService.getAADToken([environment.apiTokenScope]).pipe(
            switchMap((newToken) => {
              this.isRefreshing = false;
              this.refreshTokenSubject.next(newToken);
              const cloned = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`,
                },
              });
              return next.handle(cloned);
            }),
            catchError((err) => {
              this.isRefreshing = false;
              return next.handle(req);
            })
          );
        } else {
          return next.handle(req);
        }
      })
    );
  }
}
